import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VirtualAccountComponent } from './virtual-account.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [VirtualAccountComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
  ],
  exports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    VirtualAccountComponent
  ] 
})
export class VirtualAccountModule { }
